import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Mechanism } from './components/Mechanism';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { WhatYouGet } from './components/WhatYouGet';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    document.title = 'Código Hormonal 40+ | Guía de Bienestar para Mujeres de 40+';
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[var(--color-cream)] overflow-x-hidden" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=849651377704810&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <Nav data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Problem data-id="element-6" />
        <Mechanism data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <WhatYouGet data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}